import type { TargetWidth, TargetWidthValue } from '../types'

// Width thresholds (in pixels) - based on Adaptive Card spec
const WIDTH_THRESHOLDS: Record<TargetWidthValue, number> = {
  veryNarrow: 0,
  narrow: 300,
  standard: 400,
  wide: 500,
}

const WIDTH_ORDER: TargetWidthValue[] = ['veryNarrow', 'narrow', 'standard', 'wide']

export function getWidthCategory(width: number): TargetWidthValue {
  if (width >= WIDTH_THRESHOLDS.wide) return 'wide'
  if (width >= WIDTH_THRESHOLDS.standard) return 'standard'
  if (width >= WIDTH_THRESHOLDS.narrow) return 'narrow'
  return 'veryNarrow'
}

export function isVisibleAtWidth(targetWidth: TargetWidth | undefined, currentWidth: number): boolean {
  if (!targetWidth) return true

  const currentCategory = getWidthCategory(currentWidth)
  const currentIndex = WIDTH_ORDER.indexOf(currentCategory)

  if (targetWidth.startsWith('atLeast:')) {
    const minCategory = targetWidth.replace('atLeast:', '') as TargetWidthValue
    const minIndex = WIDTH_ORDER.indexOf(minCategory)
    return currentIndex >= minIndex
  }

  if (targetWidth.startsWith('atMost:')) {
    const maxCategory = targetWidth.replace('atMost:', '') as TargetWidthValue
    const maxIndex = WIDTH_ORDER.indexOf(maxCategory)
    return currentIndex <= maxIndex
  }

  // Exact match
  return currentCategory === targetWidth
}
